import { render, staticRenderFns } from "./HomeReinsurance.vue?vue&type=template&id=2450e0f2&scoped=true"
import script from "./HomeReinsurance.vue?vue&type=script&lang=js"
export * from "./HomeReinsurance.vue?vue&type=script&lang=js"
import style0 from "./HomeReinsurance.vue?vue&type=style&index=0&id=2450e0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2450e0f2",
  null
  
)

export default component.exports